import { useAllowedToSeeMembership } from 'src/api/Membership/useIsAllowedToSeeMembershipType'

export function useMembershipWhitelist() {
  const { isAllowedToSeeMembership } = useAllowedToSeeMembership()
  return isAllowedToSeeMembership?.isAllowed
}
